import React, { useRef, useState } from 'react'
import { Card, Col, Input, Label, Row } from 'reactstrap'
import Breadcrumb from '../../components/common/breadcrumb'
import useFormatMessage from '../../utils/useFormatMessage'

const DepoCikis = () => {
    const { t } = useFormatMessage()

    const [barcode, setBarcode] = useState("");
    const inputRef = useRef(null);

    const handleManualInputChange = (e) => {
        setBarcode(e.target.value);
    }

    return (
        <>
            <Breadcrumb current={t("Depo Çıkış")} />

            <Card className='p-4'>

                <Row className='m-2'>
                    <Col md="4">
                        <Label style={{ fontWeight: "600" }}>{t("GrupajNo")}&emsp;</Label>
                        <Input
                            ref={inputRef}
                            className="form-control input-sm text-box single-line"
                            id="Entity_Sase"
                            placeholder={t("Grupaj No Giriniz") + "..."}
                            required
                            type="text"
                            minLength={17}
                            value={barcode}
                            onChange={handleManualInputChange} // Elle giriş için durumu güncelle
                        />
                    </Col>
                </Row>

            </Card>

        </>
    )
}

export default DepoCikis